import { HVAC_INSIGHTS_ACTIONS } from '../../actions/hvacInsightsActions';

const hvacInsightsReducer = (state = {
  imageLoaded: 0,
  imagesToBeLoaded: 1,
  insights : null
}, action) => {
  switch (action.type) {
    case HVAC_INSIGHTS_ACTIONS.FETCH_DATA:
      state = {
        ...state,
        insights: action.payload
      }
      break;
    case HVAC_INSIGHTS_ACTIONS.IMAGE_LOADED:
      state = {
        ...state,
        imageLoaded: state.imageLoaded + 1
      }
      break;
    default:
      break;
  }
  return state;
};

export default hvacInsightsReducer;
